import React from 'react';
import { Modal, Button } from 'antd';
import { CrownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { UPGRADE_MODAL_CONTENTS, UpgradeModalContent } from '../../constants/upgrade';

const DescriptionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
  
  li {
    position: relative;
    padding-left: 20px;
    margin-bottom: 8px;
    color: #666;
    
    // &:before {
    //   content: "•";
    //   position: absolute;
    //   left: 8px;
    //   color: #1890ff;
    // }
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  .anticon {
    font-size: 20px;
    color: #faad14;
  }
  
  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
  }
`;

interface UpgradeModalProps {
  open: boolean;
  onCancel: () => void;
  type: keyof typeof UPGRADE_MODAL_CONTENTS;
}

export const UpgradeModal: React.FC<UpgradeModalProps> = ({ open, onCancel, type }) => {
  const navigate = useNavigate();
  const content: UpgradeModalContent = UPGRADE_MODAL_CONTENTS[type];

  const handleUpgrade = () => {
    onCancel();
    navigate('/pricing');
  };

  return (
    <Modal
      title={
        <ModalTitle>
          <CrownOutlined />
          <h3>{content.title}</h3>
        </ModalTitle>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      width={400}
      centered
    >
      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        <div style={{ marginBottom: '24px' }}>
          <DescriptionList>
            {content.description.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </DescriptionList>
        </div>
        <Button 
          type="primary" 
          block
          icon={<CrownOutlined />}
          onClick={handleUpgrade}
        >
          升级专业版
        </Button>
      </div>
    </Modal>
  );
};

export default UpgradeModal; 